import BaseNode from './BaseNode'
import SpliceIcon from '../icons/splice.svg'
import SpliceLightIcon from '../icons/splice-light.svg'
import NodeLabel from '../labels/Label'
import { DARK_MODE } from '../../constants'

const SpliceLabel = ({ ...props }) => {
  return <NodeLabel {...props} text="" />
}

export default function SpliceNode({
  node,
  onPortClick,
  onNodeClick,
  theme,
  ...props
}) {
  const { width, height } = node
  return (
    <BaseNode
      {...props}
      node={node}
      label={<SpliceLabel />}
      className="splice"
      onPortClick={onPortClick}
      onNodeClick={onNodeClick}
    >
      {(event) => (
        <image
          pointerEvents={'none'}
          width={width}
          height={height}
          href={theme == DARK_MODE ? SpliceIcon : SpliceLightIcon}
        />
      )}
    </BaseNode>
  )
}
